import { getAuth } from 'firebase/auth'
import { getFirebaseApp } from './app'

let auth: ReturnType<typeof getAuth> | null = null

export function getFirebaseAuth() {
  if (!auth) {
    auth = getAuth(getFirebaseApp())
  }
  return auth
}
